import { CaseStatus } from '@debbie/common/dist/cases/index.js';
import { ConnectCaseMappingStatus, RetractionReason, } from '@debbie/common/dist/connect/mappings/index.js';
import { useMutation } from '@debbie/common/dist/util/hooks.js';
import { objectBy } from '@debbie/common/dist/util/index.js';
import * as connect from '@debbie/cortex/dist/api/connect.js';
import { selectAuthToken } from '@debbie/cortex/dist/auth/selectors.js';
import { useEndReasons } from '@debbie/cortex/dist/end-reasons/index.js';
import { c, h } from '@debbie/cortex/dist/index.js';
import React from 'react';
import { useSelector } from 'react-redux';
import { styled } from 'styled-components';
import { Button, Panel } from '../index.js';
import HistItem from './HistItem.js';
const ConnectUpdateItem = (props) => {
    const lang = useSelector((s) => s.lang);
    const authToken = useSelector(selectAuthToken);
    const update = props.historyItem.data.update;
    const mapping = props.historyItem.data.mapping;
    const goToCreditorWeb = useMutation(async () => {
        const res = await connect.getMappingCreditorLink(mapping.id);
        window.location.href = res.link + `&authToken=${authToken}`;
    }, {
        onError: () => {
            alert(lang.connect.creditorWebLinkError);
        },
    });
    const endReasons = useEndReasons();
    const endReasonLookup = h.hasData(endReasons)
        ? objectBy(endReasons.data, (er) => er.id)
        : {};
    let header = `${lang.connect.histItemHeader} `;
    if (update.status === ConnectCaseMappingStatus.Completed) {
        header += lang.connect.histItemCompleted;
    }
    else if (update.status === ConnectCaseMappingStatus.DataUpdated) {
        header += lang.connect.histItemDataUpdated;
    }
    else if (update.status === ConnectCaseMappingStatus.Retracted) {
        header += lang.connect.histItemRetracted;
    }
    else if (update.status === ConnectCaseMappingStatus.Exported) {
        header += lang.connect.histItemExported;
    }
    return (React.createElement(HistItem, { date: props.historyItem.date, heading: header, options: [
            {
                label: lang.connect.goToConnection,
                onClick: () => {
                    c.redirect.redirect(`/settings/connect/connections/${mapping.connectConnectionId}`);
                },
            },
            {
                label: lang.connect.goToCreditorWeb,
                onClick: async () => {
                    try {
                        const res = await connect.getMappingCreditorLink(mapping.id);
                        window.location.href = res.link + `&authToken=${authToken}`;
                    }
                    catch (err) {
                        alert(lang.connect.creditorWebLinkError);
                    }
                },
            },
        ] },
        React.createElement(Panel, null,
            React.createElement(Wrapper, null, (() => {
                switch (update.status) {
                    case ConnectCaseMappingStatus.Completed: {
                        const endReason = endReasonLookup[update.data.statusLog.endReasonId];
                        return (React.createElement(React.Fragment, null,
                            endReason &&
                                update.data.statusLog.status === CaseStatus.ENDED ? (React.createElement("div", null,
                                lang.connect.completedWithReason,
                                ":",
                                ' ',
                                lang.endReason[endReason.handle] ??
                                    endReason.label)) : null,
                            update.data.foundations.length > 0 ? (React.createElement("div", null,
                                lang.connect.createdDocuments,
                                ":",
                                ' ',
                                update.data.foundations
                                    .map((doc) => {
                                    return `D${doc.id}`;
                                })
                                    .join(', '))) : null,
                            update.data.satisfactions.length === 1 ? (React.createElement("div", null,
                                lang.connect.createdSatisfaction,
                                ":",
                                ' ',
                                update.data.satisfactions[0].satisfaction,
                                "/5")) : null));
                    }
                    case ConnectCaseMappingStatus.DataUpdated: {
                        const endReason = update.data.statusLog
                            ? endReasonLookup[update.data.statusLog.endReasonId]
                            : null;
                        return (React.createElement(React.Fragment, null,
                            update.data.statusLog != null &&
                                update.data.statusLog.status === CaseStatus.ENDED ? (React.createElement("div", null,
                                lang.connect.completedWithReason,
                                ":",
                                ' ',
                                endReason != null
                                    ? (lang.endReason[endReason.handle] ?? endReason.label)
                                    : '')) : null,
                            update.data.foundations != null &&
                                update.data.foundations.length > 0 ? (React.createElement("div", null,
                                lang.connect.createdDocuments,
                                ":",
                                ' ',
                                update.data.foundations
                                    .map((doc) => {
                                    return `D${doc.id}`;
                                })
                                    .join(', '))) : null,
                            update.data.satisfactions != null &&
                                update.data.satisfactions.length === 1 ? (React.createElement("div", null,
                                lang.connect.createdSatisfaction,
                                ":",
                                ' ',
                                update.data.satisfactions[0].satisfaction,
                                "/5")) : null));
                    }
                    case ConnectCaseMappingStatus.Exported: {
                        return (React.createElement("div", { style: {
                                display: 'flex',
                                gap: '0.5em',
                                flexGrow: '1',
                            } },
                            React.createElement("div", { style: { flexGrow: '1' } },
                                React.createElement(Button, { style: { width: '100%' }, onClick: () => goToCreditorWeb.mutate(), loading: goToCreditorWeb.isLoading, disabled: goToCreditorWeb.isLoading, theme: "secondary" }, lang.connect.goToCreditorWeb))));
                    }
                    case ConnectCaseMappingStatus.Retracted:
                    default: {
                        if (update.data.reason === RetractionReason.Other) {
                            return React.createElement("div", null, update.data.reasonDescription);
                        }
                        return (React.createElement("div", null, lang.connectRetractionReason[update.data.reason]));
                    }
                }
            })()))));
};
const Wrapper = styled.div `
  display: flex;
  flex-direction: column;
  gap: 10px;
`;
export default ConnectUpdateItem;
//# sourceMappingURL=ConnectUpdateItem.js.map